export const formatTagString = (tag: string) => tag.replace('#', '');
